import React, { useState } from 'react'
import { getImageUrl } from './uspUtils'

const ExpandedUspModal = ({ onClose, onPrev, onNext, modalList, dropdownSelection, capitalize, currentItemType, isSpanishEnterprise }) => {
  const [showFullDesc, setShowFullDesc] = useState(false);
  const itemType = currentItemType || dropdownSelection;
  const imageUrl = getImageUrl(modalList, itemType);
  
  return (
    <>
    {(modalList?.closeUpURL || modalList?.focus_image_url) && <div className='flex flex-col w-[70%]'>
      <div className='relative'>
        <img
          src={imageUrl}
          alt='Expanded Usp Modal'
          className='w-full h-[16.65rem] rounded-t-lg object-cover'
        />
        <button
          className='absolute top-3 right-3 cursor-pointer bg-transparent border-0 p-0'
          onClick={onClose}
          aria-label="Close modal">
          <img
            src={'https://spyne-static.s3.us-east-1.amazonaws.com/console/crossWhite.svg'}
            alt='Cross Icon'
            fetchpriority="high"
          />
        </button>
        <div className='w-full relative'>
        <div className='flex flex-col gap-1 bg-[#222830] rounded-b-lg items-start py-3 px-4'>
          <p className='text-[#FFFFFF] text-[16px] font-semibold leading-[24px]'>
            {itemType === "EXT"
              ? (isSpanishEnterprise ? capitalize(modalList?.desc) : capitalize(modalList?.key))
              : modalList?.reasons?.[0]
                ? modalList?.reasons?.[0]
                : capitalize(modalList?.key)
            }
          </p>
          <div
            style={{
              maxHeight: showFullDesc ? '120px' : 'auto',
              overflowY: showFullDesc ? 'auto' : 'visible',
              transition: 'max-height 0.3s',
            }}
            className="w-full"
          >
            <p className='text-[#FFFFFF]/80 text-[14px] font-medium leading-[20px]'>
              {itemType === "EXT" ? (
                <>
                  {showFullDesc
                    ? (
                        <div className="flex justify-between items-start">
                          <span className="flex-1 flex flex-row justify-start" style={{textAlign: 'start'}}>
                            {modalList?.desc}
                          </span>
                          {modalList?.desc?.length > 8 && (
                            <span
                              className="text-[#FFC107] cursor-pointer ml-2 flex-shrink-0"
                              onClick={() => setShowFullDesc(false)}
                            >
                              See Less...
                            </span>
                          )}
                        </div>
                      )
                    : (
                        <div className="flex justify-between items-start">
                          <span className="flex-1 flex flex-row justify-start" style={{textAlign: 'start'}}>
                            {modalList?.desc?.length > 60
                              ? modalList?.desc?.slice(0, 60) + '...'
                              : modalList?.desc}
                          </span>
                          {modalList?.desc?.length > 60 && (
                            <span
                              className="text-[#FFC107] cursor-pointer ml-2 flex-shrink-0"
                              onClick={() => setShowFullDesc(true)}
                            >
                              See more...
                            </span>
                          )}
                        </div>
                      )
                  }
                </>
              ) : modalList?.feature
                ? modalList?.feature
                : modalList?.desc}
            </p>
          </div>
        </div>
        <div className='absolute top-[3px] right-3 flex'>
          <button onClick={onPrev} className='bg-[#22283099] rounded-full p-[8.2px]'>
            <img src="https://spyne-static.s3.us-east-1.amazonaws.com/leftMove_arrow.svg" alt="minus" className='w-7 h-7' />
          </button>
          <button onClick={onNext} className='bg-[#22283099] rounded-full p-[8.2px] ' style={{paddingLeft: '2px'}}>
            <img src="https://spyne-static.s3.us-east-1.amazonaws.com/rightMove_arrow.svg" alt="plus" className='w-7 h-7' />
          </button>
        </div>
      </div>
      </div>
    </div>}
    </>
  )
}

export default ExpandedUspModal